import React from 'react'
import '../assets/styles/sections/header.css'
import logo from '../assets/images/coinid-logo.png'
import background from '../assets/images/bg.png'

const HeaderSection = () => (
  <div className="header">
    <a href="http://myriadcoin.org">
      <img src={logo} className="header__logo" alt="logo" rel="preload" />
    </a>
    <img src={background} className="header__background" alt="background" rel="preload" />
    <div className="header__container container">
      <h1 className="header__title">
        Myriad Coin Terminal
        <br />
      
      </h1>
      <p className="header__intro">
        If the goals are met we will release a Myriad branded payment terminal with NFC function, plus a Myriad Debit Card. Linked with your cellphone app!
      </p>
    </div>
  </div>
)

export default HeaderSection



// WEBPACK FOOTER //
// ./src/sections/HeaderSection.js